var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_9073)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.982,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.94922 -0.015625C2.17383 -0.015625 2.39844 -0.015625 2.62305 -0.015625C3.68802 0.296762 4.17142 1.00965 4.07324 2.12305C3.83412 3.04563 3.23842 3.54368 2.28613 3.61719C1.33324 3.53791 0.732653 3.03986 0.484375 2.12305C0.484375 1.89844 0.484375 1.67383 0.484375 1.44922C0.689453 0.677735 1.17774 0.189453 1.94922 -0.015625Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.991,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4863 8.54056C15.4863 10.689 15.4863 12.8374 15.4863 14.9859C14.4414 14.9859 13.3965 14.9859 12.3516 14.9859C12.3565 13.062 12.3516 11.1382 12.3369 9.21439C12.2346 7.8132 11.4973 7.26146 10.125 7.55911C9.5088 7.76536 9.14259 8.19017 9.02637 8.83353C8.98755 9.01757 8.95825 9.20311 8.93848 9.39017C8.92383 11.2554 8.91894 13.1206 8.92383 14.9859C7.8789 14.9859 6.83399 14.9859 5.78906 14.9859C5.78906 11.646 5.78906 8.30618 5.78906 4.96634C6.78516 4.96634 7.78125 4.96634 8.77734 4.96634C8.77245 5.41566 8.77734 5.86487 8.79199 6.31399C9.49131 5.2318 10.4923 4.69467 11.7949 4.70267C12.7154 4.66646 13.5455 4.91548 14.2852 5.44974C14.8346 5.98689 15.1813 6.63629 15.3252 7.39798C15.3953 7.78089 15.449 8.16175 15.4863 8.54056Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.85352 14.9844C2.80859 14.9844 1.76367 14.9844 0.71875 14.9844C0.71875 11.6445 0.71875 8.30469 0.71875 4.96484C1.76367 4.96484 2.80859 4.96484 3.85352 4.96484C3.85352 8.30469 3.85352 11.6445 3.85352 14.9844Z",
    fill: "#7D7D7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_9073"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.99f173ccb466c6eddcd721f052319b41.svg";
export { ForwardRef as ReactComponent };